module.exports = __webpack_public_path__ + "img/liked.66f5c314.png";